import { BaseCommand, createTable } from "@crunchdao/shared-cli";
import {
  StakingClient,
  epochToDate,
  getCurrentEpoch,
  getPositionState,
  getPositionStateName,
  formatCrunch,
} from "@crunchdao/sdk";
import chalk from "chalk";

export class GetPositionsCommand extends BaseCommand {
  async execute(): Promise<void> {
    try {
      const stakingClient = new StakingClient({
        connection: this.provider.connection,
        wallet: this.provider.wallet,
      });

      const positions = await stakingClient.getUserPositionsAccount();
      const currentEpoch = await getCurrentEpoch(this.provider.connection);

      if (this.resolvedOptions.output === "json") {
        this.output({
          positions: positions.positions.map((p, i) => {
            const state = getPositionState(p, currentEpoch);
            return {
              index: i,
              crnchStaked: p.crnchStaked.toString(),
              coordinatorPool: p.targetWithParameters.coordinatorPool,
              state: getPositionStateName(state),
              stateValue: state,
              activationEpoch: p.activationEpoch.toString(),
              activationDate: epochToDate(p.activationEpoch).toISOString(),
            };
          }),
          currentEpoch: currentEpoch.toString(),
        });
      } else {
        console.log(chalk.cyan.bold("\n📊 Your Staking Positions"));
        console.log(chalk.gray("═".repeat(100)));
        console.log(`Current Epoch: ${currentEpoch}\n`);

        const table = createTable({
          colWidths: [8, 20, 15, 50, 28],
        });

        table.push([
          chalk.yellow("Index"),
          chalk.yellow("Amount (CRNCH)"),
          chalk.yellow("State"),
          chalk.yellow("Coordinator"),
          chalk.yellow("Activation (Epoch)"),
        ]);

        positions.positions.forEach((position, index) => {
          if (position.crnchStaked === 0n) return;

          const state = getPositionState(position, currentEpoch);
          const stateName = getPositionStateName(state);
          const amount = formatCrunch(position.crnchStaked);
          const coordinator =
            position.targetWithParameters.coordinatorPool?.coordinator?.toBase58() || "N/A";
          const activationDate = epochToDate(position.activationEpoch).toLocaleDateString();
          const activationDisplay = `${activationDate} (${position.activationEpoch})`;

          table.push([
            chalk.white(index.toString()),
            chalk.green(amount),
            chalk.cyan(stateName),
            chalk.gray(coordinator.slice(0, 8) + "..." + coordinator.slice(-8)),
            chalk.white(activationDisplay),
          ]);
        });

        console.log(table.toString());
        console.log();
      }
    } catch (error) {
      console.error("❌ Error getting positions:", error);
      throw error;
    }
  }
}
